<template>
	<div class="input-container">
		<div class="conjoin-input-containers" v-if="!field.pendingDeletion">
			<!-- Heading -->
			<div class="input-container">
				<div class="input-title add-border-bottom">Field Type</div>
				<span class="inline-buttons for-input-title">
					<a v-show="!confirmingDelete" href @click.prevent="requestDelete" tabindex="-1"><span class="fa fa-trash"></span></a>
					<a v-show="!confirmingDelete" href @click.prevent="$emit('add-field', field)" tabindex="-1"><span class="fa fa-plus"></span></a>
					<a v-show="confirmingDelete" href @click.prevent="cancelDelete" tabindex="-1"><span class="fa fa-undo"></span></a>
					<a v-show="confirmingDelete" href @click.prevent="confirmDelete" tabindex="-1"><span class="fa fa-trash"></span></a>
					<span class="input-dragger"><span class="fa fa-arrows-alt"></span></span>
				</span>
				<div class="input-box add-border-bottom">
					<selectize v-model="field.type" :settings="{ create: false }" placeholder="Select Type">
						<field-type-select-options :curated="!!module.is_curated_module"></field-type-select-options>
					</selectize>
				</div>
			</div>

			<!-- Guts -->
			<slot v-if="field.type"></slot>
		</div>

		<!-- Field Pending Deletion -->
		<a v-else href @click.prevent="undoDelete" class="alert bad-bg" tabindex="-1"><span class="fa fa-undo"></span><i>{{ field.name }}</i> will be deleted after you've saved. Click here to restore it.</a>
	</div>
</template>

<script>

import FieldTypeSelectOptions from './reusables/FieldTypeSelectOptions';

export default {

	props: {
		field: {
			type: Object,
			required: true,
		},
		module: {
			type: Object,
			default: () => ({}),
		},
	},

	data() {
		return {
			confirmingDelete: false,
			isVisible: true,
		};
	},

	methods: {

		requestDelete() {
			this.confirmingDelete = true;
			this.intRef = setTimeout(() => {
				this.confirmingDelete = false;
			}, 30000);
		},

		cancelDelete() {
			clearTimeout(this.intRef);
			this.confirmingDelete = false;
		},

		confirmDelete() {
			this.cancelDelete();
			this.$set(this.field, 'pendingDeletion', true);
			this.$emit('deleted');
		},

		undoDelete() {
			this.$set(this.field, 'pendingDeletion', false);
		},

		toggleQuickReferenceDrawer() {}

	},

	components: {
		FieldTypeSelectOptions
	},
};

</script>
